import JDILogin from "@/app/login/index.login";

/**
 登录后执行回调函数，如未登录，则自动打开登录框，登录后继续执行回调函数
 用法:
 callAfterLogin(() => {
   // 函数内部编写跳转订单页 或者 其他需要登录的页面或者必须依赖登录后的操作
 }
*/
export default async function callAfterLogin(callbackFunc: () => void) {
  const userInfo = await JDILogin.getInstance().getUserInfo();
  if (userInfo.isLoggedIn) {
    typeof callbackFunc === 'function' && callbackFunc();
  } else {
    JDILogin.getInstance().openLoginDialog((res: any) => {
      if (res && res.login_type_name === "login_success") {
        typeof callbackFunc === 'function' && callbackFunc();
      }
    });
  }
}
